<div class="rating-cta" [ngClass]="'rating-cta--' + provider.toLowerCase()">
    <div class="rating-cta__img">
        <img [src]="rankingData.logo"  [alt]="rankingData.name + ' Logo'" />
    </div>
    <div class="rating-cta__action">
        <div class="rating-cta__action_top_box"></div>
        <div class="rating-cta__action_bottom_box"></div>
        <button nbButton [routerLink]="[rankingData.route]" status="primary" [size]="buttonSize">
            {{ rankingData.translationKey | translate }} <nb-icon icon="arrow-forward-outline"></nb-icon>
        </button>
    </div>
</div>
